// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from search.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function SearchIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6 0a6 6 0 0 1 4.825 9.564l.065-.09 4.817 4.819a1 1 0 0 1-1.32 1.497l-.094-.083-4.818-4.815.058-.042A6 6 0 1 1 6 0Zm0 2a4 4 0 1 0 0 8c1 0 1.938-.367 2.651-1.003l.16-.152.15-.156A4 4 0 0 0 6 2Z"
      />
    </svg>
  );
}
